import Cookies from 'js-cookie';

const LANDING_UTM_COOKIE = 'landingPageUTMParams';

interface UTMParams {
  [key: string]: string | undefined;
}

export const readLandingPageCookie = (): UTMParams | undefined => {
  const value = Cookies.get(LANDING_UTM_COOKIE);

  if (!value) {
    return undefined;
  }

  try {
    return JSON.parse(value) as UTMParams;
  } catch {
    return undefined;
  }
};

export const writeToLandingPageCookie = (newData: UTMParams): void => {
  const cookieValue = readLandingPageCookie();
  const newValue: UTMParams = {
    ...cookieValue,
    ...newData,
  };
  Cookies.set(LANDING_UTM_COOKIE, JSON.stringify(newValue));
};
